import { z } from 'zod';
import { PHONE_REGEX, isValidPhoneNumber } from './utils/phone';

export const customerTypes = ['individual', 'contractor'] as const;

export type CustomerType = (typeof customerTypes)[number];

export enum CustomerClassificationEnum {
  INDIVIDUAL = 'individual',
  CONTRACTOR = 'contractor',
  ALL = 'all',
}

export enum ScopeTypeEnum {
  GLOBAL = 'global',
  CLASSIFICATION = 'classification',
  CUSTOMERS = 'customers',
}

export type CustomerClassification = CustomerClassificationEnum;
export type ScopeType = ScopeTypeEnum;
export type CustomerClassificationType = CustomerType;

export const customerZ = z.object({
  phone: z
    .string()
    .regex(PHONE_REGEX, 'Invalid phone number format. Must be +1 followed by 10 digits')
    .refine(isValidPhoneNumber, 'Please enter a valid US phone number'),
  email: z.email().optional(),
  name: z.object({
    first: z.string().min(1, 'First name is required'),
    last: z.string().min(1, 'Last name is required'),
  }),
  company: z
    .object({
      name: z.string().min(1).optional(),
      email: z.email().optional(),
    })
    .optional(),
  smsNotificationOptIn: z.boolean().optional(),
  marketingSmsOptIn: z.boolean().optional(),
});

export type CustomerZ = z.infer<typeof customerZ>;

export const marketingConsentEventZ = z.object({
  status: z.enum(['opted_in', 'opted_out']),
  timestamp: z.date(),
  source: z.enum(['signup', 'portal', 'admin']),
  actorId: z.string().optional(),
  actorType: z.enum(['customer', 'admin', 'system']),
  mobileNumber: z.string(),
});

export type MarketingConsentEventZ = z.infer<typeof marketingConsentEventZ>;
